import { render, staticRenderFns } from "./Checkbox.vue?vue&type=template&id=5d9e7dba&scoped=true"
import script from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
export * from "./Checkbox.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Checkbox.vue?vue&type=style&index=0&id=5d9e7dba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d9e7dba",
  null
  
)

export default component.exports